import { Box } from '@mui/material';
import { PDFViewer, Page, Text, View, Document } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getRazorPayInvoice, IWorkspacePaymentInfo, getWorkspacePaymentInfo } from 'wisestep-api';

import { useUserContext } from '../../../context';
import styles from '../../invoicing/components/invoicePreview/Styles';

type InvoicePdfParams = {
  id: string | undefined;
};

const RazorPayInvoicePdf = () => {
  const loggedInUser = useUserContext();
  const params = useParams<InvoicePdfParams>();
  const [workspaceBillingInfo, setWorkspaceBillingInfo] = useState<IWorkspacePaymentInfo | null>(
    null
  );
  const [invoice, setInvoice] = useState({});

  useEffect(() => {
    const getInvoice = async () => {
      const gstdetails = await getWorkspacePaymentInfo();
      setWorkspaceBillingInfo(gstdetails.data);
      const res = await getRazorPayInvoice(params.id ?? '');
      setInvoice(res.data);
    };
    getInvoice();
  }, [params.id]);

  const totalAmount = invoice['tax_amount'] + invoice['taxable_amount'] / 100;
  const amount = invoice['amount'] / 100;
  const percentageAmount = Math.round(totalAmount > amount ? totalAmount - amount : 0);
  const percentage = Math.round((percentageAmount / totalAmount) * 100);

  const originalAmt = (totalAmount * 100) / 118;
  const isSameState = workspaceBillingInfo?.state
    ? workspaceBillingInfo.state === 'Telangana'
    : false;

  return (
    <Box>
      <PDFViewer height={window.innerHeight + 200} width="100%">
        <Document>
          <Page size="A4" wrap>
            <View style={styles.border}>
              <View style={{ height: '100%', position: 'relative' }}>
                <Text style={styles.title}>Invoice</Text>
                <View style={styles.invoice_body}>
                  <View style={styles.half_section}>
                    <Text style={styles.subTitle}>Billed By: </Text>
                    <View style={{ flexDirection: 'row' }}>
                      <Text style={styles.subTitle_plain}>GSTIN : </Text>
                      <Text style={styles.text}>36AAGCA6692KHHH</Text>
                    </View>
                    <Text style={styles.subTitle_plain}>Avance Consulting</Text>
                    <Text style={styles.text}>
                      5-9-22,Ground Floor,My Home Sarovar Plaza Secretariat Road, Hyderabad-500063
                    </Text>
                  </View>
                  <View style={{ width: '41%', paddingLeft: 10 }}>
                    <Text style={styles.subTitle}>Avance Consulting</Text>
                    <Text style={styles.subTitle_plain}>+1 732-226-8155</Text>
                    <Text style={styles.text}>paymentsupport@wisestep-inc.com</Text>
                  </View>
                </View>

                <View style={styles.invoice_body}>
                  <View style={styles.half_section}>
                    <Text style={styles.subTitle}>Billed to: </Text>
                    <View style={{ flexDirection: 'row' }}>
                      <Text style={styles.subTitle_plain}>GSTIN : </Text>
                      <Text style={styles.text}>
                        {workspaceBillingInfo?.gst ? workspaceBillingInfo.gst : 'Not Available'}
                      </Text>
                    </View>
                    <View>
                      <Text style={styles.subTitle_plain}>
                        {`${loggedInUser?.userDTO?.firstName ?? ''} ${
                          loggedInUser?.userDTO?.lastName ?? ''
                        }`}
                      </Text>
                      {!isEmpty(workspaceBillingInfo?.address) && (
                        <Text style={styles.text}>{workspaceBillingInfo?.address ?? ''}</Text>
                      )}
                      <Text style={styles.text}>
                        {`${workspaceBillingInfo?.city} ${workspaceBillingInfo?.state} ${workspaceBillingInfo?.pincode}`}
                      </Text>
                      <Text style={styles.text}>{workspaceBillingInfo?.country ?? ''}</Text>
                    </View>
                  </View>
                  <View style={{ width: '41%', paddingLeft: 10 }}>
                    <View style={styles.midle_style}>
                      <Text style={styles.color_text}>Invoice Date:</Text>
                      <Text style={styles.text}>
                        {dayjs.unix(invoice['date'] ?? '').format('DD MMM YYYY')}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ ...styles.half_section, marginLeft: 10 }}>
                  <Text style={styles.tax_style}>{`Subscription starts from ${dayjs
                    .unix(invoice['billing_start'] ?? '')
                    .format('DD MMM YYYY')} to ${dayjs
                    .unix(invoice['billing_end'] ?? '')
                    .format('DD MMM YYYY')} `}</Text>
                  <Text style={{ ...styles.tax_style, marginTop: 4 }}>
                    Thanks for the business...!
                  </Text>
                </View>

                <View style={styles.invoice_table}>
                  <View style={styles.table_header}>
                    <Text style={{ width: '8%' }}>S. No.</Text>
                    <Text style={{ width: '45%', textAlign: 'center' }}>Description</Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>Unit Price</Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>Quantity</Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>Amount</Text>
                  </View>
                  <View style={styles.table_row}>
                    <Text style={{ width: '8%' }}>{1}</Text>
                    <Text style={{ width: '45%', textAlign: 'center' }}>
                      {invoice['line_items'] &&
                      invoice['line_items']?.[0]['name'] === 'Update Request'
                        ? 'Current plan quantity update request'
                        : invoice['line_items']?.[0]['name']}
                    </Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      {invoice['line_items'] && invoice['line_items']?.[0]['unit_amount'] / 100}
                    </Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      {invoice['line_items'] && invoice['line_items']?.[0]['quantity']}
                    </Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      {invoice['line_items'] && invoice['line_items']?.[0]['gross_amount'] / 100}
                    </Text>
                  </View>
                </View>

                <View style={styles.invoice_body}>
                  <View style={styles.half_section}></View>
                  <View
                    style={{
                      width: '40%',
                      borderColor: 'balck',
                      flexDirection: 'column',
                    }}
                  >
                    <View style={styles.border_midle_style}>
                      <Text style={styles.color_text}>Sub Total</Text>
                      <Text style={styles.text}>
                        {`${
                          invoice['currency'] == 'INR' ? 'Rs ' : invoice['currency_symbol']
                        }${originalAmt.toFixed(2)}`}
                      </Text>
                    </View>
                    {percentageAmount > 0 && (
                      <View style={styles.border_midle_style}>
                        <Text style={styles.color_text}>{`Offer(${percentage}%)`}</Text>
                        <Text style={styles.text}>
                          {invoice['currency'] == 'INR'
                            ? `Rs ${percentageAmount.toFixed(2)}`
                            : percentageAmount.toFixed(2)}
                        </Text>
                      </View>
                    )}

                    {!isSameState && (
                      <View style={styles.border_midle_style}>
                        <Text style={styles.color_text}>IGST @ 18%</Text>
                        <Text style={styles.text}>
                          {invoice['currency'] == 'INR'
                            ? `Rs ${(totalAmount - originalAmt).toFixed(2)}`
                            : totalAmount - originalAmt}
                        </Text>
                      </View>
                    )}
                    {isSameState && (
                      <View style={styles.border_midle_style}>
                        <Text style={styles.color_text}>CGST @ 9%</Text>
                        <Text style={styles.text}>
                          {invoice['currency'] == 'INR'
                            ? `Rs ${((totalAmount - originalAmt) / 2).toFixed(2)}`
                            : totalAmount - originalAmt}
                        </Text>
                      </View>
                    )}
                    {isSameState && (
                      <View style={styles.border_midle_style}>
                        <Text style={styles.color_text}>SGST @ 9%</Text>
                        <Text style={styles.text}>
                          {invoice['currency'] == 'INR'
                            ? `Rs ${((totalAmount - originalAmt) / 2).toFixed(2)}`
                            : totalAmount - originalAmt}
                        </Text>
                      </View>
                    )}

                    <View style={styles.border_midle_style}>
                      <Text style={styles.color_text}>Grand Total</Text>
                      <Text style={styles.text}>
                        {`${
                          invoice['currency'] == 'INR' ? 'Rs ' : invoice['currency_symbol']
                        }${amount}`}
                      </Text>
                    </View>
                  </View>
                </View>

                <Text
                  style={{
                    ...styles.text,
                    bottom: 0,
                    marginLeft: '14vh',
                    textAlign: 'center',
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    borderBottom: 1,
                  }}
                >
                  This is a computer-generated document. No signature is required.
                </Text>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </Box>
  );
};
export default RazorPayInvoicePdf;
